import { render, staticRenderFns } from "./ProjectPageTranslations.vue?vue&type=template&id=e052e052&scoped=true&"
import script from "./ProjectPageTranslations.vue?vue&type=script&lang=js&"
export * from "./ProjectPageTranslations.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPageTranslations.vue?vue&type=style&index=0&id=e052e052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e052e052",
  null
  
)

export default component.exports